import React from 'react';
import styled from 'styled-components';
import Card from 'components/Card';
import { Trans } from 'react-i18next';
import StyledSkeleton from 'components/Skeleton';

const NFTItemDisplayLoader: React.FC = () => {
	return (
		<StyledContainer>
			<StyleImageContainer>
				<StyledImageLoader>
					<StyledSkeleton style={{ height: '100%' }} />
				</StyledImageLoader>
			</StyleImageContainer>

			<StyledNFTName>
				<StyledSkeleton />
			</StyledNFTName>
			<StyledValueContainer>
				<div className="label">
					<Trans>Price</Trans>
				</div>
				<div className="value">
					<StyledSkeleton />
				</div>
			</StyledValueContainer>
			<StyledValueContainer>
				<div className="label">
					<Trans>Listed By</Trans>
				</div>
				<div className="value">
					<StyledSkeleton />
				</div>
			</StyledValueContainer>
		</StyledContainer>
	);
};

const StyledContainer = styled(Card)`
	height: 100%;
	position: relative;
	display: flex;
	flex-direction: column;
	box-sizing: border-box;
	justify-content: flex-end;
	cursor: pointer;

	padding: 16px;
	align-items: center;

	&:hover {
		border: 1px solid ${(props) => props.theme.color.purple[200]};
		box-shadow: 0 0 2px ${(props) => props.theme.color.purple[200]},
			0 0 4px ${(props) => props.theme.color.purple[200]},
			0 0 16px ${(props) => props.theme.color.purple[200]};

		transform: translateY(-5px);
		transition: 0.2s;
	}
`;

const StyledImageLoader = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0px;
	left: 0px;
`;

const StyleImageContainer = styled.div`
	width: 100%;
	position: relative;
	padding-top: 140%;
`;

const StyledNFTName = styled.div`
	font-style: normal;
	font-weight: bold;
	font-size: 16px;
	line-height: 18px;
	color: #fff;
	margin-bottom: 4px;
	margin-top: 22px;
	width: 100%;
`;

const StyledValueContainer = styled.div`
	display: flex;
	justify-content: space-between;
	margin-top: 8px;
	width: 100%;

	.label {
		font-style: normal;
		font-weight: normal;
		font-size: 14px;
		line-height: 16px;
		color: ${(props) => props.theme.color.grey[600]};
	}

	.value {
		font-weight: bold;
		font-size: 14px;
		line-height: 16px;
		color: #fff;
		display: flex;
		align-items: center;
	}
`;

export default NFTItemDisplayLoader;
